import { useContext, useState, useEffect } from 'react';
import { NonIdealState, Tooltip } from '@blueprintjs/core';
import { useTranslation } from 'react-i18next';
import proyectosService from '../../../services/proyectos.service';
import { AppContext } from '../../../utils/context/app.context';
import { toast } from 'react-toastify';
import { AuthContext } from '../../../utils/context/auth.context.ts';
import { useParams } from 'react-router';
import ProyectoEntregables from '../emtregables.component.js';

export default function Proyecto() {
    const PARAMS = useParams();
    const { t } = useTranslation();
    const appContext = useContext(AppContext)
    const authContext = useContext(AuthContext)

    const [item, setItem] = useState(null)
    const [isLoading, setLoading] = useState(false)
    const [canEditDocs, setEdiDocs] = useState(false)
    const [canSeeDocs, setSeeDocs] = useState(false)
    const [isADM] = useState(authContext.isSAD() || authContext.isADM())

    async function get(i) {
        if (authContext.verify({ pathname: "/pro" }, "GET")) {
            setLoading(true);
            await proyectosService.getCod(i.codigo)
                .then(res => {
                    setItem(res.data);
                    setSeeDocs(isADM || res.data.director || res.data.asignado)
                    setEdiDocs(res.data.asignado || isADM)
                })
                .catch(error => appContext.errorHandler(error, toast, t))
                .finally(() => {
                    setLoading(false);
                })
        } else {
            toast.warning(t('auth.nopermit'))
        }
    }

    useEffect(() => {
        if (!item) get({ codigo: PARAMS.id })
    }, []);


    const LOADING = <div class="text-center mt-5 pt-5">
        <div class="spinner-border" role="status">
        </div>
    </div>

    const NO_DATA = <div className='p-5'>
        <NonIdealState
            icon={'help'}
            iconSize={44}
            title={t('table.nodata')}
            description={t('table.nodatast')}
            layout={'vertical'}
        />
    </div>



    const PROYECTO = (i) => <>
    <h4 className="m-3">{t("pro.more.title_proyecto")}</h4>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.nombre")}</div>
            <div className='col fw-bold'>{i?.nombre}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.localizacion")}</div>
            <div className='col fw-bold'>{i?.municipio || ''}, {i?.direccion || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.fecha_inicio")}</div>
            <div className='col fw-bold'>{i?.fecha_inicio || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.propietario")}</div>
            <div className='col fw-bold'>{i?.propietario || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.curaduria")}</div>
            <div className='col fw-bold'>{i?.curaduria || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.fecha_entrega")}</div>
            <div className='col fw-bold'>{i?.fecha_entrega || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.observaciones")}</div>
            <div className='col fw-bold'>{i?.observaciones || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>
                <strong>{t("pro.more.entregables")}</strong>
                <br className="mb-3" />
                {i?.entregables || ''}
            </div>
        </div>
    </>

    const COTIZACION = (i) => <>
        <h4 className="m-3">{t("pro.more.title_cotizacion")}</h4>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.cotizacion")}</div>
            <div className='col fw-bold'>{i?.cotizacion || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.fecha_cotizacion")}</div>
            <div className='col fw-bold'>{i?.fecha_cotizacion || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.base")}</div>
            <div className='col fw-bold'>{appContext.cotMontoBase(i)}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.valor")}</div>
            <div className='col fw-bold'>{appContext.cotMontoTotal(i)}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.cotizador")}</div>
            <div className='col fw-bold'>{i?.cotizador || ''}</div>
        </div>
        <div className='row border p-3'>
            <div className='col'>{t("pro.more.contacto")}</div>
            <div className='col fw-bold'>{i?.correo || ''} - {i.telefono ? appContext.formatPhone(i.telefono) : ''}</div>
        </div>
    </>

    return (<>
        <div className='app-page'>

            {isLoading ? LOADING : item ?
                <div>
                    <h2>
                        {t("proyecto.title").replace("%VAR%", item.codigo)}
                        {" "}
                        {item.asignado === 1
                            ? <Tooltip content={t("pro.table.asignado")} placement="top">
                                <><span className={`bp5-icon bp5-icon-star text-warning`} /></>
                            </Tooltip>
                            : null}
                        {" "}
                        {item.director === 1
                            ? <Tooltip content={t("pro.table.director")} placement="top">
                                <><span className={`bp5-icon bp5-icon-clipboard-file text-primary`} /></>
                            </Tooltip>
                            : null}
                        {" "}
                    </h2>

                    <div className='row'>
                        <div className='col m-1'>
                            {PROYECTO(item)}
                        </div>
                        <div className='col m-1'>
                            {authContext.verify({ pathname: "/cot" }, "GET") ? COTIZACION(item) : null}
                        </div>
                    </div>

                    {canSeeDocs ? <>
                        <hr />
                        <h3>{t("proyecto.ent")}</h3>
                        <div className='container-app'>
                            <ProyectoEntregables proyecto={{ ...item, id: item.id, codigo: item.codigo }} canEdit={canEditDocs} get={get} />
                        </div>
                    </> : null}

                </div>
                : NO_DATA}
        </div>
    </>
    );
}